import {KonamiCodeDirective} from './konami-code.directive';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OpenInNewTabDirective} from './open-in-new-tab.directive';
import {HoverExpandDirective} from './hover-expand.directive';
import {ChipListAutocompleteFixDirective} from './chip-list-autocomplete-fix.directive';


@NgModule({
  declarations: [
    OpenInNewTabDirective,
    KonamiCodeDirective,
    HoverExpandDirective,
    ChipListAutocompleteFixDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OpenInNewTabDirective,
    KonamiCodeDirective,
    HoverExpandDirective,
    ChipListAutocompleteFixDirective
  ]
})
export class DirectivesModule {
}
